import { render, staticRenderFns } from "./creditors.vue?vue&type=template&id=685a985d"
import script from "./creditors.vue?vue&type=script&lang=js"
export * from "./creditors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports